export type PhoneCountry = 'CL' | 'AR' | 'BR' | 'PY';

export interface PhoneConfig {
  key: PhoneCountry;
  code: string;
  regex: RegExp;
  label: string;
}

export interface ContactPhone {
  country: PhoneCountry;
  areaCode: string;
  phone: string;
}

export const PHONE_CONFIGS: Record<PhoneCountry, PhoneConfig> = {
  CL: { key: 'CL', code: '+56', regex: /^[0-9]{9}$/, label: 'Chile' },
  AR: { key: 'AR', code: '+54', regex: /^[0-9]{10,11}$/, label: 'Argentina' },
  BR: { key: 'BR', code: '+55', regex: /^[0-9]{10,11}$/, label: 'Brasil' },
  PY: { key: 'PY', code: '+595', regex: /^[0-9]{8,10}$/, label: 'Paraguay' },
};

export const AVAILABLE_PHONE_COUNTRIES: PhoneCountry[] = ['CL', 'AR', 'BR', 'PY'];

export function getAllPhoneConfigs(): PhoneConfig[] {
  return AVAILABLE_PHONE_COUNTRIES.map(key => PHONE_CONFIGS[key]);
}
